import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, ControlContainer, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DefaultMail } from '../../../classes';

@Component({
  selector: 'app-issue-transaction-default-mails',
  templateUrl: './issue-transaction-default-mails.component.html',
  styleUrls: ['./issue-transaction-default-mails.component.css']
})
export class IssueTransactionDefaultMailsComponent implements OnDestroy, OnInit {

  formGroup: FormGroup;

  private _subscriptions: Subscription[] = [];

  constructor(
    private _formBuilder: FormBuilder,
    private _controlContainer: ControlContainer
  ) { }

  deleteEMail(email: DefaultMail){
    let index = (this.formGroup.controls['defaultMails'] as FormArray).controls.findIndex(x => (x.value as DefaultMail).mailid === email.mailid);
    if(index > -1) (this.formGroup.controls['defaultMails'] as FormArray).removeAt(index);
  }

  ngOnDestroy(): void {
    for(let sub of this._subscriptions) sub.unsubscribe();
    this._subscriptions = [];
  }

  ngOnInit(): void {
    this.formGroup = this._formBuilder.group({
      'currentEMailReceiver': this._formBuilder.control(null),
      'defaultMails': this._controlContainer.control as FormArray
    });
  }

  removeEMailAddress(email: DefaultMail, receiver: string){
    let index = email.mailreceiver.indexOf(receiver);
    if(index > -1) email.mailreceiver.splice(index, 1);
    let group = (this.formGroup.controls['defaultMails'] as FormArray).controls.find(x => (x.value as DefaultMail).mailid === email.mailid);
    group && group.markAsDirty();
  }

  setEMailAddresses(email: DefaultMail, receivers: string[]){
    email.mailreceiver = [...(email && email.mailreceiver? email.mailreceiver: []), ...receivers].filter((x, index, self) => self.indexOf(x) === index);
    let group = (this.formGroup.controls['defaultMails'] as FormArray).controls.find(x => (x.value as DefaultMail).mailid === email.mailid);
    group && group.markAsDirty();
  }

  setEMailNotification(email: DefaultMail, notificationGuid: string){
    email.maildefaultnotification = notificationGuid;
    let group = (this.formGroup.controls['defaultMails'] as FormArray).controls.find(x => (x.value as DefaultMail).mailid === email.mailid);
    group && group.markAsDirty();
  }

  get currentEMailReceiverControl(): AbstractControl {
    return this.formGroup.controls['currentEMailReceiver'];
  }

}
